import header from './global/_header'
import dropdown from './global/_dropdown'
import { accordion, accordionButton } from './global/_accordion'
import { selectInputBox, toggleButton } from './global/_form_inputs'
import { mask } from '@alpinejs/mask'
import { intersect } from '@alpinejs/intersect'
import { focus } from '@alpinejs/focus'

export default function initialiseAlpine(Alpine) {
    // Register Alpine.js plugins
    Alpine.plugin(focus)
    Alpine.plugin(intersect)
    Alpine.plugin(mask)

    document.addEventListener('alpine:init', () => {
        Alpine.data('header', header)
        Alpine.data('dropdown', dropdown)
        Alpine.data('rightAccordion', accordion)
        Alpine.data('rightAccordionButton', accordionButton)

        Alpine.data('selectInputBox', selectInputBox)
        Alpine.data('toggleButton', toggleButton)
    })
}
